import { ListQueryRequest, posicaoCarteiraListQueryModel } from "@src/core/domain/query/query.model";
import { Observable } from "rxjs";

export abstract class PosicaoCarteiraRepository {
    abstract getPosicaoCarteira(obj: ListQueryRequest): Observable<posicaoCarteiraListQueryModel>;
  }